import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import ProductAnalyticsTierBar from './ProductAnalyticsTierBar'
import ProductAnalyticsModelImprovements from '../ProductAnalyticsModelImprovements';

function ProductAnalyticsTierStats({ tierInfo, userInfo, isActive }) {
  return (
    <div>
      <ProductAnalyticsTierBar
        title="Models"
        currentScore={userInfo.modelsCount}
        requiredScore={tierInfo.requiredModels}
      />
      <div className="button-container">
        <a href="/profile/upload/model" className="btn btn-primary">Upload 3D Models</a>
      </div>
      <ProductAnalyticsTierBar
        title={isActive ? 'Publishing Score' : 'Score'}
        currentScore={userInfo.publishingScore}
        requiredScore={tierInfo.requiredScore}
        format="0.0"
      />
      <div className="button-container">
        <Link to={{ pathname: '/profile/analytics/improvements' }} className="btn btn-primary">Model Improvements</Link>
      </div>
    </div>
  )
}

ProductAnalyticsTierStats.propTypes = {
  tierInfo: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
}

export default ProductAnalyticsTierStats
